import { useFactoryAccess } from "../../lib/permissions";
import { LaneBadge } from "../lane-badge";
import { StatusBadge } from "../status-badge";
import {
  ArtifactsCard,
  isOpenWorkOrder,
  OperatorInstructions,
  PullFromLineButton,
  type TaskDetail,
  useProduction,
  useTaskDetail,
  type WorkOrderAccess,
  WorkOrderMeta,
  WorkOrderProduction,
} from "../tasks/work-order";
import { Skeleton } from "../ui/skeleton";

/**
 * The issue's work order: its route, the station working now, every station run, and what the line
 * produced. The merge ticket and a human hold stay in the Factory card beside it.
 */
export function FactoryTab({ taskId }: { taskId: string }) {
  const access = useFactoryAccess();
  const query = useTaskDetail(taskId);
  if (query.isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-10 w-2/3" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }
  if (!query.data)
    return <p className="text-sm text-muted-foreground">The work order could not be loaded.</p>;
  return <FactoryTabBody data={query.data} access={access} />;
}

function FactoryTabBody({ data, access }: { data: TaskDetail; access: WorkOrderAccess }) {
  const { task, artifacts } = data;
  const { spend } = useProduction(data);
  return (
    <div className="flex min-w-0 flex-col gap-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 space-y-2">
          <div className="flex flex-wrap items-center gap-2">
            <StatusBadge status={task.status} />
            <LaneBadge task={task} />
          </div>
          <WorkOrderMeta task={task} spend={spend} />
        </div>
        {access.actions && isOpenWorkOrder(task) && <PullFromLineButton taskId={task.id} size="sm" />}
      </div>
      <WorkOrderProduction data={data} access={access} />
      <ArtifactsCard artifacts={artifacts} />
      {task.instructions && <OperatorInstructions instructions={task.instructions} />}
    </div>
  );
}
